import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, CardBody, Col, Form, Input, Label, Row, Spinner, Table } from 'reactstrap';
import { GlobalStore } from '../../../StateStores';
import { toast } from 'react-toastify';
import { getFireTransactionDetails } from '../../../Actions/InvoiceActs';

const FireArmDetails = ({transaction,toggleModal})=>{
    const [details, setDetails] = useState([]);
    const {InvoiceDispatch} = useContext(GlobalStore);

    const loadFirearmDetails = async ()=>{
        try {
            const response = await getFireTransactionDetails({
                transaction_id:transaction?.fireId,
            })(InvoiceDispatch)
            if(response.status){
                setDetails(response.data)
            }
        } catch (error) {
            toast.error(error.message)
        }
    }

    useEffect(()=>{
        loadFirearmDetails();
    },[transaction])

    return(
        <React.Fragment>
            <Card className='shadow-sm'>
                <CardBody>
                    <Table bordered size="sm" className='caption-top'>
                        <thead className="bg-light">
                            <tr>
                                <th>#</th>
                                <th className='text-center'>Full name</th>
                                <th className='text-center'>Mobile</th>
                                <th className='text-center'>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(details || []).map((detail,index)=>(
                                <tr>
                                    <td>{++index}</td>
                                    <td>{detail?.name}</td>
                                    <td>{detail?.mobile}</td>
                                    <td>{detail?.amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default FireArmDetails